import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';
import access from './access.png';
import card from './avec3.png';
import brush from './brush.png';
import lightBulb from './lightBulb.png';
import mapPinIcon from './mapPinIcon.png';
import practicalInfo from './practicalInfo.png';
import vehicles from './vehicles.png';
import camera from './camera.png';

import css from './TabNav.module.css';


function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const Tab = props => {
  const { className, id, disabled, text, selected, linkProps } = props;




  const linkClasses = classNames(css.link, {
    [css.selectedLink]: selected,
    [css.disabled]: disabled,
  });


  const image = id === "EditListingWizard_location" ? (
    <img src={mapPinIcon} className={css.tabLabelImg}/>
  ) : id === "EditListingWizard_description" ? (
    <img src={brush} className={css.tabLabelImg}/>
  ) : id === "EditListingWizard_policy" ? (
    <img src={practicalInfo} className={css.tabLabelImg}/>
  ) : id === "EditListingWizard_vehicleCompatibility" ? (
    <img src={vehicles} className={css.tabLabelImg}/>
  ) : id === "EditListingWizard_features" ? (
    <img src={access} className={css.tabLabelImg}/>
  ) : id === "EditListingWizard_specialInfo" ? (
    <img src={lightBulb} className={css.tabLabelImg}/>
  ) : id === "EditListingWizard_pricing" ? (
    <img src={card} className={css.tabLabelImg}/>
  ) : <img src={camera} className={css.tabLabelImg}/>


  return (
    <div id={id} className={className}>
      <NamedLink className={linkClasses} {...linkProps}>
        {text}
        {/* {image} */}
      </NamedLink>
      
    </div>
  );
};

Tab.defaultProps = { className: null, disabled: false, selected: false };

const { arrayOf, bool, node, object, string } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
};

const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs } = props;
  const classes = classNames(rootClassName || css.root, className);
  const tabClasses = tabRootClassName || css.tab;
  const [width, height] = useWindowSize(); 

  return (
    <nav className={classes}>
      {tabs.map((tab, index) => {
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
    
        return(
            <div className={css.tabLabelWrapper}>
           <Tab key={id} id={id} className={tabClasses} {...tab} />
            </div>
           );
      })}
      <br/>
      {
         width > 900 ? (
          <div className={css.phoneInfo}>
          Nous sommes heureux de répondre à vos questions 7j / 7 : <br/> <strong><a href="tel:06-58-11-51-47">06 58 11 51 47</a></strong>
          </div>
         ) : null
      }
     
    </nav>
  );
};

TabNav.defaultProps = {
  className: null,
  rootClassName: null,
  tabRootClassName: null,
  tabClassName: null,
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
};

export default TabNav;
